import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class InstructionsStore {
    loader = true;
    instructions = [];
    instruction = [];

    getInstructions = () => {
        this.loader = true;
        Api.fetch('instructions')
            .then(response => {
                if (response.success) {
                    this.instructions = response.result.category;
                }
            })
            .finally(() => (this.loader = false));
    };

    getInstruction = id => {
        this.loader = true;
        Api.fetch(`instructions/${id}`)
            .then(response => {
                if (response.success) {
                    this.instruction = response.result;
                }
            })
            .finally(() => (this.loader = false));
    };

    clearInstructions = () => (this.instructions = []);
}

decorate(InstructionsStore, {
    loader: observable,
    instructions: observable,
    instruction: observable,

    getInstructions: action,
    getInstruction: action,
    clearInstructions: action,
});
